import { TOGGLE_DIALOG_MODAL } from '../actionTypes';

interface Action {
  type: string;
}

const dialogModal = (dialogModal = false, action: Action): boolean => {
  switch (action.type) {
    case TOGGLE_DIALOG_MODAL:
      return !dialogModal;

    default:
      return dialogModal;
  }
};

export default dialogModal;
